<template>
  <!-- 平台账户 -->
 <div >
   <div class="top" ref="top">
     <el-card shadow="hover">
       <div class="topCont">
         <div class="left">
           <div class="itemBox shrink">
              <div class="item">
                <el-tooltip  effect="dark" content="账户总金额，包含平台账户金额和客户账户金额" placement="top-start">
                  <span>总资金池：</span>
                </el-tooltip>
                <span style="font-size:18px;color:red;font-weight:600;">&nbsp;&nbsp;&nbsp;{{topData.ext1}}</span>
                <span>元</span>
              </div>
              <div class="item">
                 <el-tooltip  effect="dark" content="平台运费及邮费总收入减去运费总支出所剩金额" placement="top-start">
                  <span>平台账户：</span>
                </el-tooltip>
                  <span style="color:#0e6eec;font-size:18px;">&nbsp;&nbsp;&nbsp;{{topData.ext3}}</span><span>元</span>
              </div>
              <div class="item">
                <el-tooltip effect="dark" content="货主、车队及司机的暂存在平台及待提现的金额合计" placement="top-start">
                  <span>客户账户：</span>
                </el-tooltip>
                <span style="color:#0e6eec;font-size:18px;">&nbsp;&nbsp;&nbsp;{{topData.ext2}}</span><span>元</span>
              </div>
           </div>
         </div>
         <div class="center shrink">
            <el-button  type="primary"  @click="zijinClick" >资金划转</el-button>
            <el-button  type="primary"  v-if="btnFlg[5]" size="" @click="withdrawalClick" >提现</el-button>
            <el-button type="text"  v-if="btnFlg[5]"  @click="tixianjinduFn()">提现详情</el-button>
         </div>
         <div class="right shrink">
              <el-button type="text"    @click="hzjiluFn()"><span class="font2">划转记录</span></el-button>
              <span class="font2" v-if="btnFlg[7]" @click="zhszFN">账户设置</span>
              <span class="font2" v-if="btnFlg[6]" @click="bankcardClick">银行卡</span>
              <el-button type="text"    @click="pzjiluFn()"><span class="font2">平账记录</span></el-button>
              <el-button type="text"    @click="freezeFn()"><span class="font2">冻结记录</span></el-button>
              <el-dropdown class="my-dropdown">
                <span class="el-dropdown-link">
                  <span class="font2">交易密码</span>
                 <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit-outline" @click.native="changePassWordClick()">修改交易密码</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-unlock" @click.native="setUp()">设置/忘记交易密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
               <!-- <el-button type="text"    @click="chakanFN()"><span class="font2">银行账户余额</span></el-button> -->
          </div>
       </div>
     </el-card>
  </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="客户名称:" prop="accountName">
                <el-input  placeholder="" v-model="searchFrom.accountName"></el-input>
              </el-form-item>
              <el-form-item label="客户类型:" prop="accountType">
                <el-select  v-model="searchFrom.accountType"   placeholder="请选择">
                  <el-option label="平台" value="0"></el-option>
                  <el-option label="货主" value="1"></el-option>
                  <el-option label="司机" value="2"></el-option>
                  <el-option label="车队" value="3"></el-option>
                  <el-option label="车队长" value="4"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="油卡状态:" prop="gCardStatus">
                <el-select  v-model="searchFrom.gCardStatus"   placeholder="请选择">
                  <el-option label="不开通" value="1"></el-option>
                  <el-option label="未开通" value="2"></el-option>
                  <el-option label="开通中" value="3"></el-option>
                  <el-option label="已开通" value="4"></el-option>
                  <el-option label="开通失败" value="5"></el-option>
                  <el-option label="变更中" value="6"></el-option>
                  <el-option label="变更失败" value="7"></el-option>
                </el-select>
              </el-form-item> -->
             <!-- <el-form-item label="变更状态:" prop="changeStatus">
                <el-select placeholder="请选择" v-model="searchFrom.changeStatus">
                  <el-option
                    v-for="item in changeState"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
             <el-form-item btnCode="00JP007B001" v-if="btnFlg[0]">
                <el-button type="primary" @click="searchFn">查询</el-button>
             </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
            </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' :row-class-name="tableRowClassName"
       height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="操作" width="170">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" btnCode="00JP007B004" v-if="btnFlg[3]"  @click="jiaoyiFn(scope.row)">交易明细</el-button>
                <el-button type="text" size="mini" btnCode="00JP007B004" v-if="scope.row.accountType==0"  @click="pingzhangFn(scope.row)">平账</el-button>
                <!-- <el-button type="text" size="mini" btnCode="00JP007B004" v-if="btnFlg[3]"  @click="xinyongjinFn(scope.row)">信用金</el-button> -->
                <!-- <el-button type="text" size="mini" @click="OilFN(scope.row)" v-if="btnFlg[9]&&scope.row.gCardStatus == 4">油卡账户余额</el-button>
                <el-button type="text" size="mini" @click="OpenOilCard(scope.row)" v-if="btnFlg[8]&&scope.row.gCardStatus == 2">开通油卡</el-button> -->
                <!-- <el-button type="text" size="mini" @click="changeOilCard(scope.row)" v-if="btnFlg[8]&&scope.row.accountType==2">变更油卡</el-button> -->
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="accountName" width="320"   label="客户名称" align="center"  ></el-table-column>
         <el-table-column property="accountType" label="客户类型" min-width="130">
          <template scope="scope">{{[ "平台", "货主","司机", "车队", "车队长"][scope.row.accountType]}}</template>
        </el-table-column>
        <el-table-column prop="zxAccNo"  width="200"  label="资金分薄号" align="center"  :formatter="emptyFn"  ></el-table-column>
         <el-table-column label="资金分薄余额"   width="140">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="00JP007B005" v-if="scope.row.zxAcountId&&scope.row.accountClassify==1&&btnFlg[4]"   @click="chakanFN(scope.row)">查看</el-button>
              <span v-if="!scope.row.zxAcountId">-</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="accountNo"   label="平台账号"  width="200" align="center"   :formatter="emptyFn" ></el-table-column>
        <!-- <el-table-column prop="accountMoney"   label="平台余额"  width="200" align="center"   :formatter="emptyFn" ></el-table-column> -->
        <el-table-column label="平台余额"   width="140">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" v-if="scope.row.accountType==0"   @click="chakanPTFN(scope.row)">{{scope.row.accountMoney}}</el-button>
              <span v-else>{{scope.row.accountMoney}}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="creditMoney"   label="信用金额度" width="120"  align="center"  :formatter="emptyFn"  ></el-table-column>
        <el-table-column prop="creditBalance"   label="信用金余额" width="120"  align="center"  :formatter="emptyFn"  ></el-table-column>
        <el-table-column prop="blockBalance"   label="信用金冻结" width="120"  align="center"   :formatter="emptyFn" ></el-table-column>
        <el-table-column property="updateTime" label="最后交易时间" width="170"  align="center" :formatter="dateTimeFormat" ></el-table-column>
        <!-- <el-table-column property="isGCard" label="油卡状态" min-width="130">
          <template scope="scope">{{[ "不开通", "未开通","开通中","己开通"][scope.row.isGCard-1]}}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="gCardStatus" label="油卡状态" min-width="130" :formatter="statusFormat1"></el-table-column> -->
        <!-- <el-table-column property="changeStatus" label="变更状态" min-width="140" :formatter="statusFormat1"> </el-table-column> -->
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 修改交易密码 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeDialog"
    :visible.sync="changePasswordMark"
    width="500px"
    center>
      <span>
         <el-form
          :model="changePasswordFrom"
          :rules = rules
          :validate-on-rule-change = "false"
          ref="changePasswordFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item label="" prop="" style="margin-top:20px;">
            <span style="color:#ccc;">提示：交易密码为6位数字</span>
          </el-form-item>
          <el-form-item label="原密码:" prop="oldPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="changePasswordFrom.oldPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="changePasswordFrom.newPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="newPwdOne" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="changePasswordFrom.newPwdOne" style="width:200px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="settlementSubmit('changePasswordFrom')"  :loading='SubmitLoading'>修改</el-button>
        <el-button @click="settlementClose('changePasswordFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 设置交易密码 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="setUpPasswordMark"
     @close="closeDialog"
    width="500px"
    center>
      <span>
         <el-form
          :model="setUpPasswordFrom"
          :rules = rules2
          :validate-on-rule-change = "false"
          ref="setUpPasswordFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item label="" prop="" style="margin-top:20px;">
            <span style="color:#ccc;">提示：交易密码为6位数字</span>
          </el-form-item>
          <el-form-item label="手机号:" prop="receivePhone" style="margin-top:20px;">
            <span>{{setUpPasswordFrom.receivePhone}}</span>
          </el-form-item>
          <el-form-item label="验证码:" prop="code" style="margin-top:20px;">
            <el-input  placeholder="" v-number-input.float="0" maxlength="" auto-complete="new-password"  v-model.trim="setUpPasswordFrom.code" style="width:100px;"></el-input>
            <el-button  size='mini' type="primary" v-if="isShowGetCode" @click="codeClick">获取验证码</el-button>
             <span v-else class="identiCode"
                >{{ countdown }}s后可重试</span
              >
          </el-form-item>
          <el-form-item label="设置密码:" prop="newPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" auto-complete="new-password" v-number-input.float="0" maxlength="6"  v-model.trim="setUpPasswordFrom.newPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="newPwdOne" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="setUpPasswordFrom.newPwdOne" style="width:200px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="setUpSubmit('setUpPasswordFrom')"  :loading='setSubmitLoading'>确定</el-button>
        <el-button @click="setUpClose('setUpPasswordFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!-- 银行账号余额 -->
    <el-dialog  title="银行账号余额"  :visible.sync="dialogYE" width="400px"   :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="yueBox "><span class="redFont">{{zxAcoun}}</span>元</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogYE = false">关闭</el-button>
      </span>
   </el-dialog>
    <!-- 油卡账户余额 -->
    <el-dialog  title="油卡账户余额"  :visible.sync="oilYE" width="400px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="yueBox "><span class="redFont">{{oilcoun}}</span>元</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="oilYE = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 平台余额 -->
    <el-dialog  title="平台余额"  :visible.sync="dialogPTYE" width="400px"   :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
        <div class="yueBox ">
            <div class="item"><label>平台余额：</label><span class="redFont">{{PTYUdata.value1}}</span>元</div>
            <div class="item"><label>结算未提现：</label><span class="redFont">{{PTYUdata.value2}}</span>元</div>
            <div class="item"><label>合计金额：</label><span class="redFont">{{PTYUdata.value3}}</span>元</div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPTYE = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 选择账户 -->
    <el-dialog  title="选择账户"  :visible.sync="dialogXZZH" width="800px"   :close-oni-click-modal="false"  :close-on-press-escape="false" center>
     <el-table :data="zhanghuList" ref="table" bordersize="mini" :row-class-name="tableRowClassName"
        class="table" height="300px" style="width: 100%"   center  border   >
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text"  @click="zhanghuOk(scope.row)" size="mini">选择账户</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="accountNo"  label="平台账号"></el-table-column>
        <el-table-column prop="accountName" min-width="300"   :show-overflow-tooltip="true" label="公司名称"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogXZZH = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 平账 -->
    <el-dialog  title="平账"  :visible.sync="PZMark" width="400px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="PZFrom" ref="PZFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
             <div style="display: flex;justify-content: space-between; ">
                <p>当前平台账户：<span style="color:red;font-size:18px">{{PZFrom.lastBalanceMoney}}</span>元</p>
                <!-- <p>平账后金额：<span >{{PZFrom.accountMoney}}</span>元</p> -->
             </div>
             <div style=" margin: 28px 0;">
                <el-form-item label="操作类型:" prop="operationType" class="jiage">
                  <el-select  v-model="PZFrom.operationType"  placeholder="请选择"  >
                    <el-option  label="增" value="0" ></el-option>
                    <el-option  label="减" value="1" ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="平账费目:" prop="operationName" class="jiage">
                  <el-select  v-model="PZFrom.operationName"  placeholder="请选择"  >
                    <el-option  label="提现手续费" value="1" ></el-option>
                    <el-option  label="银行利息" value="2" ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="平账金额:" class="jiage" prop="balanceMoney"  >
                  <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="PZFrom.balanceMoney"  ></el-input><span class="danwei">元</span>
                </el-form-item>
                 <el-form-item label="平账原因:" class="jiage" prop="reason"  >
                   <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100" v-model="PZFrom.reason"></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PZMark = false">取消</el-button>
        <el-button type="primary" @click="PZsave()">确定</el-button>
      </span>
   </el-dialog>
   <!-- 资金划转 -->
    <el-dialog  title="资金划转"  :visible.sync="ZJMark" width="400px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="zjFrom" ref="zjFrom" :rules="rules3" class="demo-form-inline jiaoyan" label-width="140px" size="mini">
        <div class="inpBox">
             <div style=" margin: 28px 0;">
               <div>
                <el-form-item label="转出账户名称:" prop="customerName" class="jiage" >
                  <el-select v-model="zjFrom.customer" filterable placeholder="请选择" value-key="id" @change="zjChangge">
                     <el-option
                      v-for="item in zjList"
                      :key="item.id"
                      :label="item.accountName"
                      :value="item">
                     </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转出账号:" class="jiage" prop="zxAccNo" >
                  <el-input  placeholder="" v-model="zjFrom.zxAccNo" :readonly="true" class="disabled"></el-input>
                </el-form-item>
               </div>
               <div>
                 <el-form-item label="转入账户名称:" prop="recCustomerName" class="jiage">
                    <el-select v-model="zjFrom.customer1" filterable placeholder="请选择" value-key="id" @change="zjChangge1">
                     <el-option
                      v-for="item in zjList"
                      :key="item.id"
                      :label="item.accountName"
                      :value="item">
                     </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转入账号:" class="jiage" prop="recZxAccNo"  >
                 <el-input  placeholder="" v-model="zjFrom.recZxAccNo" :readonly="true" class="disabled"></el-input>
                </el-form-item>
               </div>
                <el-form-item label="划转金额:" class="jiage" prop="transMoney"  >
                  <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="zjFrom.transMoney"  ></el-input><span class="danwei">元</span>
                </el-form-item>
                 <el-form-item label="划转原因:" class="jiage" prop="reason"  >
                   <el-input style="width: 160px" type="textarea" :rows="3"  placeholder="" maxlength="100" v-model="zjFrom.reason"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="mobile">
                 <span>{{zjFrom.mobile}}</span>
                </el-form-item>
                <el-form-item label="验证码:" prop="code" class="jiage" >
                 <el-input  placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="zjFrom.code" style="width:163px;"></el-input>
                 <el-button  size='mini' v-if="isShowGetCode2"   type="primary" @click="codeClick2" class="danwei1">获取验证码</el-button>
                 <span v-else class="identiCode1" >{{ countdown2 }}s后可重试</span>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZJMark = false">取消</el-button>
        <el-button type="primary" @click="HZsave()">确定</el-button>
      </span>
   </el-dialog>
   <!-- 提现详情 -->
    <tixianjinduList  :row-data="topData" v-if="zujianFlag" @destroy="destroy"></tixianjinduList>
 </div>

</template>

<script>
import { emptyFn, dateTimeFormat, encryption } from '@/utils/util'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import {
  custInfoDetail,
  tAccountCustinfoList, // 列表 资金划转
  sendSmsCode, // 验证码
  firstUpdateBankCardPayPwd, // 设置密码
  changePassWord, // 修改密码
  searchSjAmt, // 余额,
  platformAmountSum, // 平台余额
  platformAcclist, // 选择账户得列表
  pingZhang, // 平账
  tranAccountMoney, // 资金划转-确定
  addDriverFirstCard,
  FuelCard // 油卡账户余额
} from '@/api/consignment'
import tixianjinduList from '@/components/networkFreight/tixianjinduList.vue'
export default {
  components: {
    tixianjinduList
  },
  data () {
    return {
      oilYE: false,
      // changeState: [
      //   { name: '正常', value: 1001 },
      //   { name: '变更成功', value: 1401 },
      //   { name: '变更失败', value: 1402 }
      // ],
      // 资金划转获取验证码
      isShowGetCode2: true,
      countdown2: 60,
      timer2: '',
      zujianFlag: false,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      topData: {},
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      // 查看银行余额
      dialogYE: false,
      zxAcoun: 0,
      oilcoun: 0,
      changePasswordMark: false,
      changePasswordFrom: {
        oldPwd: '',
        newPwd: '',
        newPwdOne: ''
      },
      title: '平台账户',
      SubmitLoading: false,
      rules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPwdOne: [
          { required: true, message: '请输入确认密码', trigger: 'blur' }
        ],
        operationType: [
          { required: true, message: '请选择操作类型', trigger: 'blur' }
        ],
        operationName: [
          { required: true, message: '请选择平账费目', trigger: 'blur' }
        ],
        balanceMoney: [
          { required: true, message: '请输入平账金额', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入平账原因', trigger: 'blur' }
        ]
      },
      rules2: {
        receivePhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请设置密码', trigger: 'blur' }
        ],
        newPwdOne: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ]
      },
      // 划转
      rules3: {
        customerName: [
          { required: true, message: '请选择转出账户名称', trigger: 'blur' }
        ],
        recCustomerName: [
          { required: true, message: '请选择转入账户名称', trigger: 'blur' }
        ],
        transMoney: [
          { required: true, message: '请输入划转金额', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入划转原因', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      setUpPasswordMark: false,
      setUpPasswordFrom: {
        id: '',
        receivePhone: '',
        code: '',
        newPwd: '',
        newPwdOne: ''
      },
      isShowGetCode: true,
      countdown: 60,
      accountId: '',
      setSubmitLoading: false,
      dialogXZZH: false, // 选择账户
      zhanghuList: [],
      xzFlag: null, // 1提现，2银行卡，3设置密码，4.修改密码
      // 划转
      zjList: [],
      zjFrom: {
        code: ''
      },
      ZJMark: false,
      // 平账
      PZFrom: {},
      PZMark: false,
      // 信用金
      XYJFrom: {},
      XYJMark: false,
      // 平台余额
      PTYUdata: {},
      dialogPTYE: false,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00JP007B001', '00JP007B002', '00JP007B003', '00JP007B004', '00JP007B005',
        '00JP007B006', '00JP007B007', '00JP007B008', '00JM0S0100', '00JM0S0200']
    }
  },
  created () {
    this.getTopData()
    this.btnFlg = getBtn(this.btnIdArr, '/payAccount')
    this.getList(this.searchFrom)
    platformAcclist({ accountStatusList: [3, 4, 5] }).then(res => {
      this.zhanghuList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight + this.$refs.top.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 110) + 'px'
  },
  methods: {
    statusFormat1 (row, column, cellValue) {
      switch (cellValue) {
        case '1':
          return '不开通'
        case '2':
          return '未开通'
        case '3':
          return '开通中'
        case '4':
          return '已开通'
        case '5':
          return '开通失败'
        case '6':
          return '变更中'
        case '7':
          return '变更失败'
      }
    },
    // 开通油卡
    OpenOilCard (row) {
      this.$confirm('是否执行开通油卡操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addDriverFirstCard({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '开通成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 变更油卡
    // changeOilCard (row) {
    //   this.$confirm('是否执行变更油卡操作?', '系统提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消'
    //   }).then(() => {
    //     const loading = this.$loading({
    //       lock: true,
    //       text: '正在处理...'
    //     })
    //     addDriverFirstCard({ id: row.id }).then(res => {
    //       loading.close()
    //       this.$message({
    //         message: '变更成功',
    //         type: 'success'
    //       })
    //       this.getList(this.searchFrom)
    //     }).catch(error => {
    //       this.$message({
    //         showClose: true,
    //         message: error.message,
    //         type: 'error',
    //         onClose () {
    //           loading.close()
    //         }
    //       })
    //     })
    //   }).catch(() => {

    //   })
    // },
    // 获取验证码
    codeClick2 () {
      this.countDown2()
      this.isShowGetCode2 = false
      sendSmsCode({
        account: this.zjFrom.mobile // 动态获取手机号
      }).then(res => {
        // this.$set(this.zjFrom, 'mobile', res.mobile)
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    countDown2 () {
      const self = this
      this.timer2 = setInterval(() => {
        self.countdown2--
        if (self.countdown2 === 0) {
          clearInterval(self.timer2)
          self.countdown2 = 60
          self.isShowGetCode2 = true
        }
      }, 1000)
    },
    // 划转
    zijinClick () {
      this.ZJMark = true
      this.$nextTick(() => {
        this.$refs['zjFrom'].clearValidate()
      })
      this.$set(this.zjFrom, 'mobile', localStorage.getItem('mobile'))
      // 资金划转 账户列表
      tAccountCustinfoList({ pageNo: 1, pageSize: 2000, accountTypeList: [0, 1] }).then(res => {
        this.zjList = res.list
      })
    },
    zjChangge (val) {
      // console.log(this.zjFrom);
      // console.log(this.zjFrom.customer);
      this.zjFrom.customer = val
      this.zjFrom.accountId = this.zjFrom.customer.id
      this.zjFrom.customerName = this.zjFrom.customer.accountName
      this.zjFrom.zxAccNo = this.zjFrom.customer.zxAccNo
      // if(this.zjFrom.accountType != 0 && this.zjFrom.accountType != 1){
      //   this.$message.error('暂不支持司机，车队长进行资金划转')
      // }
    },
    zjChangge1 (val) {
      // console.log(this.zjFrom);
      // console.log(this.zjFrom.customer1);
      this.zjFrom.customer1 = val
      this.zjFrom.recAccountId = this.zjFrom.customer1.id
      this.zjFrom.recCustomerName = this.zjFrom.customer1.accountName
      this.zjFrom.recZxAccNo = this.zjFrom.customer1.zxAccNo
      // if(this.zjFrom.accountType != 0 && this.zjFrom.accountType != 1){
      //   this.$message.error('暂不支持司机，车队长进行资金划转')
      // }
    },
    HZsave () {
      this.$refs.zjFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tranAccountMoney(this.zjFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.ZJMark = false
            this.isShowGetCode2 = true
            this.countdown2 = 60
            clearInterval(this.timer2)
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 划转记录
    hzjiluFn () {
      this.$router.push('/payAccount/transferRecords')
    },
    // 平台余额查询
    chakanPTFN (row) {
      platformAmountSum({ id: row.id }).then(res => {
        this.PTYUdata = res
        this.dialogPTYE = true
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 平账记录
    pzjiluFn () {
      this.$router.push('/payAccount/pingZhangJiLu')
    },
    // 平账
    pingzhangFn (row) {
      this.$set(this.PZFrom, 'lastBalanceMoney', row.accountMoney)
      this.$set(this.PZFrom, 'id', row.id)
      this.$set(this.PZFrom, 'accountMoney', row.accountMoney)
      this.PZMark = true
    },
    PZsave () {
      this.$refs.PZFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          pingZhang(this.PZFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.PZMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 信用金
    xinyongjinFn () {

    },
    // 账户设置
    zhszFN () {
      this.$router.push('/payAccount/zhangHuSet')
    },
    // 选择账户
    zhanghuOk (row) {
      if (this.xzFlag == 1) {
        if (row.bankAccount != '' && row.lastuserPwd != '') {
          this.$router.push({ path: '/payAccount/withdrawal', query: { id: row.id } })
        } else {
          DonMessage.error('请先绑定银行卡并设置交易密码')
        }
      } else if (this.xzFlag == 2) {
        this.$router.push({ path: '/payAccount/bankcard', query: { id: row.id } })
      } else if (this.xzFlag == 3) {
        this.setUpPasswordFrom.id = row.id
        this.$set(this.setUpPasswordFrom, 'receivePhone', row.receivePhone)
        this.setUpPasswordMark = true
        this.dialogXZZH = false
      } else if (this.xzFlag == 4) {
        this.changePasswordFrom.id = row.id
        this.changePasswordMark = true
        this.dialogXZZH = false
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isDefault == 1 && row.accountType == 0) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 点击提现
    withdrawalClick () {
      this.dialogXZZH = true
      this.xzFlag = 1
    },
    // 提现详情
    tixianjinduFn () {
      this.zujianFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
    },
    // 点击银行卡
    bankcardClick () {
      this.dialogXZZH = true
      this.xzFlag = 2
    },
    // 交易明细
    jiaoyiFn (row) {
      this.$router.push({ name: 'payAccountJiaoYiMX', query: { id: row.id, type: row.accountType } })
    },
    // 查看
    chakanFN (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      searchSjAmt({ id: row.zxAcountId }).then(res => {
        loading.close()
        this.dialogYE = true
        this.zxAcoun = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 查看
    OilFN (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      FuelCard({ id: row.id }).then(res => {
        loading.close()
        this.oilYE = true
        this.oilcoun = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 获取头部金额
    getTopData () {
      custInfoDetail({ accountType: 0, accountCode: localStorage.getItem('tenantCode') }).then(res => {
        this.topData = res
        this.getList(this.searchFrom)
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取验证码
    codeClick () {
      this.countDown()
      this.isShowGetCode = false
      sendSmsCode({
        account: this.setUpPasswordFrom.receivePhone
      }).then(res => {

      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 修改密码弹框
    changePassWordClick () {
      this.dialogXZZH = true
      this.xzFlag = 4
      this.title = '修改密码'
    },
    settlementSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = encryption({
            data: this.changePasswordFrom,
            key: this.global.key,
            param: ['oldPwd', 'newPwd', 'newPwdOne']
          })
          this.SubmitLoading = true
          changePassWord({
            id: this.changePasswordFrom.id,
            oldPwd: data.oldPwd,
            newPwd: data.newPwd,
            newPwdOne: data.newPwdOne
          }).then(res => {
            this.SubmitLoading = false
            DonMessage.success('修改成功')
            this.changePasswordMark = false
          }).catch(err => {
            this.SubmitLoading = false
            DonMessage.error(err.message)
          })
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    settlementClose (formName) {
      this.changePasswordMark = false
      this.$refs[formName].resetFields()
    },
    // 点击设置密码
    setUp () {
      this.dialogXZZH = true
      this.xzFlag = 3
      this.title = '设置密码'
    },
    // 设置密码确定
    setUpSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = encryption({
            data: this.setUpPasswordFrom,
            key: this.global.key,
            param: ['newPwd', 'newPwdOne']
          })
          this.setSubmitLoading = true
          firstUpdateBankCardPayPwd({
            id: this.setUpPasswordFrom.id,
            receivePhone: this.setUpPasswordFrom.receivePhone,
            code: this.setUpPasswordFrom.code,
            newPwd: data.newPwd,
            newPwdOne: data.newPwdOne
          }).then(res => {
            this.setSubmitLoading = false
            DonMessage.success('设置成功')
            this.setUpPasswordMark = false
            this.isShowGetCode = true
            this.countdown = 60
            clearInterval(this.timer)
            this.setUpPasswordFrom = {
              receivePhone: '',
              code: '',
              newPwd: '',
              newPwdOne: ''
            }
            this.getTopData()
          }).catch(err => {
            this.setSubmitLoading = false
            DonMessage.error(err.message)
          })
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 设置密码取消
    setUpClose (formName) {
      this.setUpPasswordMark = false
      this.$refs[formName].resetFields()
    },
    // 冻结记录
    freezeFn () {
      this.$router.push({ name: 'payAccountFreeze' })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tAccountCustinfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.isShowGetCode2 = true
      this.countdown2 = 60
      clearInterval(this.timer2)
      this.zjFrom = {}
      this.CHFrom = {}
      this.changePasswordFrom = {}
      this.setUpPasswordFrom = {}
      this.PZFrom = {}
    }
  }
}
</script>
<style scoped lang='less'>
.top{
  width: 98%;
  margin: 0 auto;
  margin-bottom: 20px;
  .topCont{
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .font2{
    cursor: pointer;
    color:#409EFF;
    margin-left:40px;
    font-size: 14px;
  }
  /deep/.el-icon-arrow-down{
      color:#409EFF;
  }
  .itemBox{
    display: flex;
    .item{
      margin-right: 30px;
      flex-shrink: 0;
    }
  }
  span{
    font-size: 14px;
  }
}
/deep/.el-table .warning-row {
    background: #aeec90!important;
  }
  .shrink{flex-shrink: 0;}
.yueBox{
  text-align: center;
  label{
    width: 100px;
    text-align: right;
    display: inline-block;
  }
  .item{
    margin-bottom: 12px;
  }
}
.redFont{
  color: red;
  font-size: 20px;
}
/deep/.inpBox .el-input__inner {
    width: 160px!important;
}
.jiage .el-form-item__content {
  position: relative;
  .danwei1 {
    position: absolute;
    right: 4px;
    color: white;
  }

}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 4px;
    color: #409eff;
  }

}
</style>
